import {
    Directive,
    Input,
    HostListener,
    ElementRef
} from '@angular/core';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { DatePipe } from '@angular/common';

// Define, export a directive used to format a date 'matInput' control.
//
// Note:  much of the code in the following directive was taken from the following article:
//        https://medium.com/angular-in-depth/angular-material-matinput-control-with-thousands-separation-ebcbb7b027f4.
@Directive({
    selector: '[dateFormat]',
    providers: [
        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: CustomDateFormatDirective }
        // Note:  could not make the directive implement NG_VALUE_ACCESSOR as component
        //        DateFormFieldComponent implements NG_VALUE_ACCESSOR (I forget the exact
        //        error message, but it will come back if the following code is enabled).
        /*
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CustomDateFormatDirective,
            multi: true,
        }
        */
    ],
    standalone: false
})
export class CustomDateFormatDirective {
    // Properties.
    @Input() formatString: string = null;

    private _value: string | null;
    private fnOnChange = (_ignored: any) => { }; // Initial, NOOP function.

    // Constructor.
    public constructor(private elementRef: ElementRef<HTMLInputElement>) {
        return;
    }

    // Life cycle methods.
    
    public ngOnInit(): void {
        // PJH - added this line to addresss VNEXT-2123 in which formatting was not being applied on initial Form load
        this.formatValue(this.elementRef.nativeElement.value);
        return;
    }
    // End life cycle methods.

    // Implement MAT_INPUT_VALUE_ACCESSOR.
    public get value(): string | null {
        return this._value;
    }

    @Input('value')
    public set value(value: string | null) {
        this._value = value;
        this.formatValue(value);
    }

    // Implement one of the NG_VALUE_ACCESSOR methods but not the interface itself
    // (per comments above).  As this directive does not implement NG_VALUE_ACCESSOR,
    // the following writeValue() method is not called by the Angular framework.
    // Instead, it it calls manually from code in DateFormFieldComponent.
    public writeValue(value: any): void {
        this._value = value;
        this.formatValue(this._value); // format Value
    }

    @HostListener('blur')
    _onBlur() {
        if (this.elementRef && this.elementRef.nativeElement && this.elementRef.nativeElement.value) {
            this.formatValue(this.elementRef.nativeElement.value);
        }

        return;
    }

    @HostListener('focus')
    onFocus() {
        return;
    }
    // End handling of control methods.

    // Private helper methods.
    private formatValue(value: string | null): void {
        if (value !== null) {
            this.elementRef.nativeElement.value = this.applyDateFormatting(value);
        } else {
            this.elementRef.nativeElement.value = '';
        }

        return;
    }

    private applyDateFormatting(value: string | null): string {
        let datePipe: DatePipe = new DatePipe('en-US');
        let formattedValue: string = datePipe.transform(value, this.formatString);

        return (formattedValue);
    }

    // Define a public version of applyDateFormatting() so the logic for such formatting
    // is only contained in this directive class (rather than being repeated in class DateFormFieldComponent).
    public static applyDateFormattingUsing(formatString: string, value: string): string {
        let datePipe: DatePipe = new DatePipe('en-US');
        let formattedValue: string = datePipe.transform(value, formatString);

        return (formattedValue);
    }
}
